import React from 'react';
import './VideoSection.css';

export default function VideoSection() {
  return (
    <section className="video-section">
      <div className="video-container">
        <iframe
          src="https://player.vimeo.com/video/1140532999?muted=0&autoplay=1&loop=1&background=1&app_id=122963"
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          title="Vimeo Video"
        ></iframe>
      </div>
    </section>
  );
} 